import DistrictLogs from './DistrictLogs';
export default DistrictLogs;
